module.exports = "<p>\n  manage-auction-configuration works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-auction-configuration/manage-auction-configuration.component.html
// module id = ./src/app/manage-auction-configuration/manage-auction-configuration.component.html
// module chunks = main